var _circle, _line, _line2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessageWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-alert-circle",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 10
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 8,
    x2: 12,
    y2: 12
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 16,
    x2: 12.01,
    y2: 16
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageWarning);
export default __webpack_public_path__ + "static/media/message-warning.26282881583dcc1c3371b0885a1e6df9.svg";
export { ForwardRef as ReactComponent };